namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_statistics, {
		position: 'absolute',
		left: $mol_gap.block,
		bottom: $mol_gap.block,
		zIndex: $mol_layer.float,
		pointerEvents: 'none',
		flex: { direction: 'column' },
		color: $mol_theme.shade,
		font: { size: '.875rem' },
		lineHeight: '1.125rem',
	} )
}
